import { render, staticRenderFns } from "./theoryDetailInfo.vue?vue&type=template&id=9ae40bca&scoped=true"
import script from "./theoryDetailInfo.vue?vue&type=script&lang=js"
export * from "./theoryDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./theoryDetailInfo.vue?vue&type=style&index=0&id=9ae40bca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae40bca",
  null
  
)

export default component.exports